import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CqExtraParamsDestination } from 'src/app/beans/components/cq-extra-params/cq-extra-params-destination.bean';
import { Contract } from 'src/app/beans/contract/contract.bean';
import { GuidedCreation } from 'src/app/beans/guided-creation/guided.creation.bean';
import { User } from 'src/app/beans/login/user/user.bean';
import { ServiceContractSlot } from 'src/app/beans/service/service.contract.slot.bean';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { Notifier } from 'src/app/enums/notifier/notifier.enum';
import { isSessionCode } from 'src/app/enums/session/session-code.enum';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';

@Component
({
  selector: 'stepper-module-2',
  templateUrl: './module.2.html',
  styleUrls: ['./module.2.scss']
})

export class StepperModule2 implements OnInit 
{
  _service        : ServiceContractSlot
  _guided_creation: GuidedCreation = null

  _contracts: Contract[] = []
  
  
  maxCounter: number[] = []

  @Input ('orgId') orgId: number
  @Output() change: EventEmitter<number> = new EventEmitter<number>()

  constructor
  (
    private _handler : HandlerManager,
    private _util    : UtilsManager   ,
    private _notifier: NotifierManager,
    private _session : SessionManager 
  ) {}


  async ngOnInit()
  {
    await this.retrieveContracts()
    this.initObjects()
  }

  async retrieveContracts(){

    let user = this._session.user().get()

    if( !User.isKind( user )) return 

    user = user as User

    const dest: CqExtraParamsDestination = {
      codes   : [ 
        "TIPOLOGIA_CONTRATTO"
      ],
      level   : "OR",
      type    : "WAPP",
      levelid : this.orgId
    }

    const resp = await this._handler.extraParams().getParamByCode(user.token, dest)
    console.log(resp);
    if(!resp) return 

    this._contracts = JSON.parse( resp.text1 )
    this.maxCounter = [1]
  }

  checkInput()
  {
    this.initObjects()


    this._service.booking = this._service.booking && this.canEnableBooking() ? 1 : 0 
    console.log(this._service);

    this._service.name1 = this.formatName(this._service.name1)
    this._service.name2 = this.formatName(this._service.name2)
    this._service.name3 = this.formatName(this._service.name3)
    this._service.name4 = this.formatName(this._service.name4)
    this._service.name5 = this.formatName(this._service.name5)    
    this._service.name6 = this.formatName(this._service.name6)    

    if(!this._util.checker().isValidText(this._service.name1))
    {
      this._notifier.show(Notifier.WARNING, NotifierMessage.INVALID_SERVICE_NAME_1)
      this.change.emit(0)
      return
    }

    //If all data was checked then
    this._guided_creation.service = this._service


    
    this._session.guidedCreation().set(this._guided_creation)

    this.change.emit(1)
  }

  initObjects()
  {
    if(!this._guided_creation)
    {
      let object = this._session.guidedCreation().get() as GuidedCreation

      console.log(object);

      if(!isSessionCode(object))
      {
        this._guided_creation = object

        if(this._guided_creation.service) this._service = this._guided_creation.service
        else                              this._service = new ServiceContractSlot()
      }
      else
      {
        this._guided_creation = new GuidedCreation()
        this._service = new ServiceContractSlot()
      }
    }
  }

  contractChange(el: Contract)
  {
    this._guided_creation.pharma   = el.type
    this._guided_creation.pharmaId = el.id
    switch (el.maxCounter) 
    {
      case 1: 
      {
        this.maxCounter = [1]
        this._service.name3 = null
        this._service.name4 = null
        this._service.name5 = null    
        break
      }
      case 4: 
      {
        this.maxCounter = [1,2,3,4]
        this._service.name5 = null         
        break
      }
      case 6: 
      this.maxCounter = [1,2,3,4,5,6]; 
      
      break;
    }

  }

  formatName( str: string ){
    if( ! str ) return null
    if( str.trim().length == 0 ) return null

    return str.trim()
  }

  canEnableBooking(){
    return this.maxCounter.length > 1;
  }
}
